import { Filter } from 'bad-words'

const filter = new Filter()

// Add additional sexualized/inappropriate terms beyond the default list
filter.addWords(
  'sexytime', 'hookup', 'hook up', 'booty call', 'bootycall',
  'onlyfans', 'fwb', 'nsfw', 'nudes', 'sugardaddy', 'sugarbaby',
  'escort', 'dominatrix', 'bdsm', 'fetish', 'hentai',
)

/**
 * Check if a string contains profane or inappropriate language.
 */
export function containsProfanity(text: string): boolean {
  return filter.isProfane(text)
}

/**
 * Return a cleaned version of the string with profane words replaced.
 */
export function cleanProfanity(text: string): string {
  return filter.clean(text)
}
